import React from "react";
import { TableBody } from "@mui/material";
import { useFormContext } from "react-hook-form";

import RoutingTableRow from "./RoutingTableRow";
import { ROUTINGS as OPTIONS } from "../../constants";
import RoutingHiddenRows from "./RoutingHiddenRows";
import PartRoutingDetails from "./PartRoutingDetails";

const RoutingTableBody = () => {
  const { watch } = useFormContext();
  const routings = watch("routings") || [];

  const shown = OPTIONS?.filter((route) => routings?.includes(route.id));
  const hasHidden = shown?.length !== OPTIONS?.length;

  return (
    <TableBody paddingBottom="200px">
      <PartRoutingDetails />
      {shown?.map((route) => (
        <RoutingTableRow key={route.id + "shown"} route={route} />
      ))}
      {hasHidden && <RoutingHiddenRows />}
    </TableBody>
  );
};

export default RoutingTableBody;
